import React, { useState } from "react";
import { Link } from "react-router-dom";
import hospitalIcon from "../images/hospitalPlugin.png";
import stethoscopeIcon from "../images/stethoscopePlugin.png";
import bloodIcon from "../images/bloodPlugin.png";

const LeftSidePlugins: React.FC = () => {
  const [active, setActive] = useState<"doctor" | "opinion" | "health" | null>(null);

  const commonBase =
  "hidden lg:flex fixed left-0 items-center rounded-r-2xl shadow-2xl shadow-black/25 overflow-hidden" +
  " transition-all duration-700 ease-out z-[9999] cursor-pointer backdrop-blur-sm hover:scale-[1.02] active:scale-[0.98]";

  const closedWidth = "w-14";
  const openWidth = "w-90";
  const pluginHeight = "h-14";

  const handleEnter = (key: typeof active) => setActive(key);
  const handleLeave = () => setActive(null);

  const plugins = [
    {
      id: "doctor" as const,
      top: "top-[31%]",
      bg: "bg-gradient-to-r from-[#e8f8e1] to-[#e8f8e1]",
      textColor: "#1a5f1a",
      icon: hospitalIcon,
      title: "Find A Doctor",
      path: "/doctors",
    },
     {
      id: "health" as const,
      top: "top-[40%]",
      bg: "bg-gradient-to-r from-[#ffe5e5] to-[#ffe5e5]",
     
      textColor: "#7b1515",
      icon: bloodIcon,
      title: "Book Health Checkup",
      path: "https://ramahospital.com/health-check-up/",
    },
    {
      id: "opinion" as const,
      top: "top-[49%]",
      bg: "bg-gradient-to-r from-[#dcfafb] to-[#dcfafb]",
    
      textColor: "#004b57",
      icon: stethoscopeIcon,
      title: "Get Expert Opinion",
      path: "https://ramahospital.com/book-an-appointment/",
    },
   
  ];

  return (
    <>
      {plugins.map((plugin) => (
        <Link
          key={plugin.id}
          to={plugin.path}
          className={`${commonBase} ${plugin.top} ${pluginHeight} ${plugin.bg} ${
            active === plugin.id ? openWidth : closedWidth
          }`}
          onMouseEnter={() => handleEnter(plugin.id)}
          onMouseLeave={handleLeave}
        >
          <div className="flex items-center gap-2 px-4 w-full h-full">
            {/* Icon circle - FIXED for images */}
            <div className={`flex-shrink-0 w-10 h-10 rounded-md  flex items-center justify-center `}>
              <img
                src={plugin.icon}
                alt={`${plugin.title} icon`}
                className="w-10 h-10 object-contain mr-3"
              />
            </div>
            {/* Text part */}
            <div
              className={`font-semibold w-fit text-sm transition-all duration-700 ease-out whitespace-nowrap flex-1 ${
                active === plugin.id
                  ? "opacity-100 translate-x-0 delay-150"
                  : "opacity-0 -translate-x-6"
              }`}
            >
              <div
                className={`text-base font-semibold transition-all duration-300 ${
                  active === plugin.id ? "text-sm" : "text-sm"
                }`}
                style={{ color: plugin.textColor }}
              >
                {plugin.title}
              </div>
            </div>
            {/* Arrow circle */}
            <div
              className={`ml-auto flex-shrink-0 w-6 h-6 rounded-full border-2 bg-white/90 shadow-md flex items-center justify-center transition-all duration-700 ease-out ${
                active === plugin.id
                  ? "opacity-100 scale-100 translate-x-0 rotate-0"
                  : "opacity-0 scale-75 translate-x-4 -rotate-90"
              }`}
              style={{ borderColor: plugin.textColor }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke={plugin.textColor}
                strokeWidth="2"
                className="transition-transform duration-500"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </Link>
      ))}
    </>
  );
};
export default LeftSidePlugins;
